import { getTranslation } from '@easy-expense/intl-client';
import { Icon } from '@easy-expense/ui-shared-components';
import { Layout, OpenSans } from '@easy-expense/ui-web-core';
import React from 'react';

import { KeyHint } from './KeyHint.component';

const PageButton: React.FC<{
  iconName: string;
  label: string;
  hint: string;
  onClick: () => void;
}> = ({ iconName, label, hint, onClick }) => {
  const [hover, setHover] = React.useState(false);

  return (
    <Layout.Column style={{ position: 'relative' }}>
      <Layout.PressableColumn
        style={{ background: 'none' }}
        px
        onClick={onClick}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <Icon name={iconName} size={16} color={'white'} />
      </Layout.PressableColumn>

      {hover ? (
        <KeyHint
          label={label}
          hint={hint}
          style={{ bottom: 36, left: '50%', transform: 'translateX(-50%)' }}
        />
      ) : null}
    </Layout.Column>
  );
};

/**
 * Dark pill showing the current receipt position (e.g. "2 / 3") with back and
 * forward page buttons. Shared by the expense edit viewer and the receipt
 * preview modal so both surfaces page through receipts identically.
 */
export const ReceiptPageControl: React.FC<{
  selectedReceiptIndex: number;
  count: number;
  onPrevious: () => void;
  onNext: () => void;
  style?: React.CSSProperties;
}> = ({ selectedReceiptIndex, count, onPrevious, onNext, style }) => {
  if (count <= 1) {
    return null;
  }

  return (
    <Layout.Row
      py
      style={{
        boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
        ...style,
      }}
      bg="brandPrimaryDark"
      radius
      align
    >
      <PageButton
        iconName="chevron-back"
        label={getTranslation('Previous receipt')}
        hint="←"
        onClick={onPrevious}
      />
      <OpenSans.Inverse size="xs-12">
        {selectedReceiptIndex + 1} / {count}
      </OpenSans.Inverse>
      <PageButton
        iconName="chevron-forward"
        label={getTranslation('Next receipt')}
        hint="→"
        onClick={onNext}
      />
    </Layout.Row>
  );
};
